export default {
    en: {
        fetchingQuestions: 'Fetching questions...',
        submitAnswer: 'Submit Answer',
        viewResults: 'View Results',
        fetchingPoll: 'Fetching poll...',
    },
    in: {
        fetchingQuestions: 'Mengambil pertanyaan...',
        submitAnswer: 'Kirim Jawaban',
        viewResults: 'Lihat Hasil',
        fetchingPoll: 'Mengambil jajak pendapat...',
    },
    zh: {
        fetchingQuestions: '正在获取问题...',
        submitAnswer: '提交答案',
        viewResults: '查看结果',
        fetchingPoll: '正在获取投票...',
    },
    nl: {
        fetchingQuestions: 'Vragen ophalen...',
        submitAnswer: 'Antwoord indienen',
        viewResults: 'Resultaten bekijken',
        fetchingPoll: 'Peiling ophalen...',
    },
    fi: {
        fetchingQuestions: 'Haetaan kysymyksiä...',
        submitAnswer: 'Lähetä vastaus',
        viewResults: 'Näytä tulokset',
        fetchingPoll: 'Haetaan äänestystä...',
    },
    fr: {
        fetchingQuestions: 'Récupération des questions...',
        submitAnswer: 'Soumettre la réponse',
        viewResults: 'Voir les résultats',
        fetchingPoll: 'Chargement du sondage...',
    },
    de: {
        fetchingQuestions: 'Fragen werden geladen...',
        submitAnswer: 'Antwort absenden',
        viewResults: 'Ergebnisse anzeigen',
        fetchingPoll: 'Umfrage wird geladen...',
    },
    hi: {
        fetchingQuestions: 'प्रश्न लाए जा रहे हैं...',
        submitAnswer: 'उत्तर सबमिट करें',
        viewResults: 'परिणाम देखें',
        fetchingPoll: 'पोल लाया जा रहा है...',
    },
    it: {
        fetchingQuestions: 'Caricamento delle domande...',
        submitAnswer: 'Invia risposta',
        viewResults: 'Visualizza risultati',
        fetchingPoll: 'Caricamento del sondaggio...',
    },
    ja: {
        fetchingQuestions: '質問を取得中...',
        submitAnswer: '回答を送信',
        viewResults: '結果を見る',
        fetchingPoll: '投票を取得中...',
    },
    ko: {
        fetchingQuestions: '질문을 불러오는 중...',
        submitAnswer: '답변 제출',
        viewResults: '결과 보기',
        fetchingPoll: '설문 불러오는 중...',
    },
    pl: {
        fetchingQuestions: 'Pobieranie pytań...',
        submitAnswer: 'Prześlij odpowiedź',
        viewResults: 'Zobacz wyniki',
        fetchingPoll: 'Pobieranie ankiety...',
    },
    pt: {
        fetchingQuestions: 'Buscando perguntas...',
        submitAnswer: 'Enviar resposta',
        viewResults: 'Ver resultados',
        fetchingPoll: 'Buscando enquete...',
    },
    es: {
        fetchingQuestions: 'Obteniendo preguntas...',
        submitAnswer: 'Enviar respuesta',
        viewResults: 'Ver resultados',
        fetchingPoll: 'Obteniendo encuesta...',
    },
    tr: {
        fetchingQuestions: 'Sorular getiriliyor...',
        submitAnswer: 'Cevabı Gönder',
        viewResults: 'Sonuçları Gör',
        fetchingPoll: 'Anket getiriliyor...',
    },
    vi: {
        fetchingQuestions: 'Đang lấy câu hỏi...',
        submitAnswer: 'Gửi câu trả lời',
        viewResults: 'Xem kết quả',
        fetchingPoll: 'Đang lấy thăm dò...',
    },
    ar: {
        fetchingQuestions: 'جارٍ جلب الأسئلة...',
        submitAnswer: 'إرسال الإجابة',
        viewResults: 'عرض النتائج',
        fetchingPoll: 'جارٍ جلب الاستطلاع...',
    }
};
